<ng-container>
    <ng-container *ngIf="type==='parent'; else childView">
        <div>
            <div class="row-new add-first">
                <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
                    <span class="form-inline-new">
                        <p class="lob-headers additional-padding-bottom">MBO Owner
                        </p>
                    </span>

                    <mat-form-field *ngIf="!newMBOSegmentClicked" [floatLabel]="'never'" class="add-dropdown lob-border">
                        <input class="lob-new-dropdown edit text-notavailable-option option-size" />
                        <mat-select
                            [ngModel]="selectedLeaderObject ?? null"
                            (ngModelChange)="AddLobDataUpdated.Leader_Name = $event?.Leader_Name"
                            placeholder="Select an MBO Owner"
                        >
                            <mat-option class="dropDownList" *ngFor="let element of uniqueMBOOwners" [value]="element">
                            {{ element.Leader_Name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
                    <span class="form-inline-new">
                        <p class="lob-headers">MBO Year
                            <span class="uitk-icon sm-icon"></span>
                        </p>
                    </span>
                    <mat-form-field *ngIf="!newMBOSegmentClicked" [floatLabel]="'never'" class="add-dropdown lob-border">
                      <mat-select
                        [(ngModel)]="AddLobDataUpdated.Decom_Target_Year"
                        placeholder="Select an MBO Target Year"
                      >
                        <mat-option class="dropDownList" *ngFor="let element of MBOTargetYear" [value]="element">
                          {{ element }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
                    <span class="form-inline-new">
                        <p class="lob-headers">MBO
                            <span class="uitk-icon sm-icon"></span>
                        </p>
                    </span>
                    <input [(ngModel)]="AddLobDataUpdated.Decom_Target" Placeholder="Enter MBO" class="lob-add-input lob-border">
                </div>
            </div>
            <div class="pull-right lob-add-apply-margin">
                <button mat-mdc-raised-button (click)="onSubmit('parent')" [disabled]="isSegmentDetailsUnchanged()" class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
                    Apply
                </button>
            </div>    
        </div>
    </ng-container>

    <ng-template #childView>
        <div>
            <div class="row-new add-first">
        <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
            <span class="lob-new">
                <p class="lob-headers">MBO Segment
                    <span class="uitk-icon sm-icon"></span>
                </p>

                <button *ngIf="!newMBOSegClicked" (click)="toggleSegmentButton()" mat-mdc-raised-button class="create-new-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
                    Create New
                </button>
                <button *ngIf="newMBOSegClicked" (click)="toggleSegmentButton()" mat-mdc-raised-button class="create-new-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
                    Existing LOB
                </button>
            </span>

                <mat-form-field *ngIf="!newMBOSegClicked" [floatLabel]="'never'" class="add-dropdown lob-border">
                    <input class="lob-new-dropdown edit text-notavailable-option option-size" />
                    <mat-select [ngModel]="selectedSegmentObject"
                        (ngModelChange)="AddLobDataUpdated.MBO_Segment = $event?.MBO_Segment"
                        placeholder="Select an existing MBO Segment">
                        <mat-option class="dropDownList" *ngFor="let seg of uniqueMBOSegments" [value]="seg">
                            <ng-container>
                                {{ seg.MBO_Segment }}
                            </ng-container>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <input *ngIf="newMBOSegClicked" [(ngModel)]="AddLobDataUpdated.NewAddedSegment" Placeholder="Enter a new MBO Segment"
                    class="lob-newLob lob-add-input lob-border">
        </div>
            </div>
            <div class="pull-right lob-add-apply-margin">
                <button mat-mdc-raised-button (click)="onSubmit('child')" [disabled]="!newMBOSegClicked ? isSegmentUnchanged() : disableApplyFromAdd()" class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
                    Apply
                </button>
            </div>    
        </div>
    </ng-template>
</ng-container>